import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P0003600 } from '../../../../P0003600';
import { P0003601 } from '../../../../P0003601';
import { P0004700 } from '../../../../P0004700';
import { P00046 } from '../../../../P00046';
import { P0003606ESPInstallationPhComponent } from '../../../../P0003606/EnSavoirPlus/p0003606-espinstallation-ph/p0003606-espinstallation-ph.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P0003605ESPInstallationClComponent } from '../../../../P0003605/InjectionChlore/EnSavoirPlus/p0003605-espinstallation-cl/p0003605-espinstallation-cl.component';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00080ConsignPH, P00080ConsignRX } from '../../../Enum/P00080Consigne';
import { P00058 } from '../../../../P00058';
import { P0006600 } from '../../../../P0006600';

@Component({
  selector: 'app-p00080-altimeo-parameters',
  templateUrl: './p00080-altimeo-parameters.component.html',
  styleUrls: ['./p00080-altimeo-parameters.component.scss'],
  imports: [
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
  ],
})
export class P00080AltimeoParametersComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private slideModalService: SlideModalController =
    inject(SlideModalController);

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalController: SlideModalController =
    inject(SlideModalController);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {
    this.P00080InstallationCl = this.P00080InstallationCl.bind(this);
    this.P00080InstallationPh = this.P00080InstallationPh.bind(this);
  }

  async P00080InstallationCl() {
    const modal = await this.slideModalController.create({
      component: P0003605ESPInstallationClComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  async P00080InstallationPh() {
    const modal = await this.slideModalController.create({
      component: P0003606ESPInstallationPhComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  hasProduitP0003600() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003600()) ?? 0;
  }

  hasProduitP0003601() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003601()) ?? 0;
  }

  hasProduitP0004700() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0004700()) ?? 0;
  }

  hasProduitP00046() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00046()) ?? 0;
  }

  hasProduitP00058() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00058()) ?? 0;
  }

  hasProduitP0006600() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0006600()) ?? 0;
  }

  async P0003606ESPInstallationPh() {
    const modal = await this.slideModalService.create({
      component: P0003606ESPInstallationPhComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00080ConsignRX = P00080ConsignRX;
  protected readonly P00080ConsignPH = P00080ConsignPH;
}
